import { render, staticRenderFns } from "./UserInfoForm.vue?vue&type=template&id=1fdc0902"
import script from "./UserInfoForm.vue?vue&type=script&lang=js"
export * from "./UserInfoForm.vue?vue&type=script&lang=js"
import style0 from "./UserInfoForm.vue?vue&type=style&index=0&id=1fdc0902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports